var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatchQuery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.574 4.979L8.5 7.509l-6.074-2.53c-.41-.171-.41-.777 0-.949L8.5 1.5l6.073 2.53c.41.172.41.778 0 .949zM3.928 4.505L8.5 6.41l4.572-1.905L8.5 2.6 3.928 4.505z",
    fill: "#222B40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.028v1.227l6.501 2.858L15 8.256V7.03L8.501 9.886 2 7.028z",
    fill: "#222B40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.42v1.228l6.501 2.858L15 11.649v-1.227l-6.499 2.857L2 10.419z",
    fill: "#222B40"
  })));
}
export default SvgBatchQuery;